import { Trascodifica, Cap, Comune, Provincia } from ".";

export class Collaboratore 
{
	dataCreazione: Date;
	id: number;
	nome: string;
	cognome: string;
	telefono: string;
	cellulare: string;
	email: string;
	note: string;
	idTipologiaPosizione: number;
	tipologiaPosizione: Trascodifica;
	pIva: string;
	nomeFileVisuraCamerale: string;
	nomeFileCv: string;
	nomeFileContratto: string;
	dataFileContratto: Date;
	captchaResponse: string;
	idStato: number;
	stato: Trascodifica;
	cap: Array<Cap>;
	comuni: Comune[];
	provincia: Provincia[];
	informativaPrivacy: boolean;
	codiceCollaboratore: string;
	convenzione: string;

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/collaboratore.ts